import { useState } from 'react'
import { Trans, t } from '@lingui/macro'
import { Alert, Button, IconButton, Stack, Tooltip } from '@mui/material'
import MergeIcon from '@mui/icons-material/MergeType'
import SwapIcon from '@mui/icons-material/SwapHoriz'

import { Patient } from '@/core/models/patient.model'

import MergeDetailsDialog from './MergeDetailsDialog'

type ReviewMergeAlertProps = {
  onSwapPatients: () => void
  resetPatientSelection?: () => void
  primaryPatient?: Patient
  secondaryPatient?: Patient
}

export function ReviewMergeAlert({ onSwapPatients, resetPatientSelection, primaryPatient, secondaryPatient }: ReviewMergeAlertProps) {
  const [openDialog, setOpenDialog] = useState(false)

  if (!primaryPatient || !secondaryPatient) return null

  return (
    <>
      <Alert
        severity="info"
        icon={<MergeIcon />}
        action={
          <Stack direction="row" spacing={1}>
            <Tooltip title={t`Swap patients`}>
              <IconButton size="small" onClick={onSwapPatients} color="inherit">
                <SwapIcon />
              </IconButton>
            </Tooltip>
            <Button size="small" variant="contained" onClick={() => setOpenDialog(true)}>
              <Trans>Review Merge</Trans>
            </Button>
          </Stack>
        }
      >
        <Trans>Two patients selected. Click "Review Merge" to continue or swap the primary/secondary roles.</Trans>
      </Alert>
      <MergeDetailsDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onSubmitSuccess={resetPatientSelection}
        primaryPatient={primaryPatient}
        secondaryPatient={secondaryPatient}
      />
    </>
  )
}
